import React from "react";
import { useNavigate } from "react-router-dom";
import Allcategory from "../../data/category.json";
import slugify from "../../utils/slugify";

const GameTags = ({ tags }) => {
    const navigate = useNavigate();

    if (!Array.isArray(tags)) return null;

    const handleCategoryClick = (title) => {
        title = slugify(title)
        navigate(`/games/${title}`);
    };

    return (
        <div className="flex flex-wrap gap-2 mt-4">
            {tags.map((tag, index) => {
                const categoryDetails = Allcategory.find(cat => cat.title === tag.trim());

                if (!categoryDetails) return null;
                const safeTagClass = tag.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

                return (
                    <button
                        key={index}
                        onClick={() => handleCategoryClick(categoryDetails.title)}
                        className={`
                            tag-${safeTagClass}
                            bg-[#1e1e2f] 
                            text-sm md:text-base 
                            text-white 
                            hover:text-[#FF007F] 
                            border border-[#FF007F] 
                            px-3 py-1 
                            rounded-full 
                            transition 
                            duration-200 
                            hover:shadow-[0_0_10px_#FF007F] 
                            cursor-pointer
                        `}
                    >
                        {tag}
                    </button>
                );
            })}
        </div>
    );
};

export default GameTags;
